module.exports = __webpack_public_path__ + "img/hydronic-calcs.fbbd69b0.png";